import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      try {
        // Multiple approaches to ensure scroll to top
        
        // Method 1: Standard window.scrollTo with immediate behavior
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant'
        });
        
        // Method 2: Direct property manipulation
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        // Method 3: Alternative window methods
        window.pageYOffset = 0;
        if (window.scrollY !== undefined) {
          window.scrollTo(0, 0);
        }
        
        // Method 4: Reset any scrollable containers
        const scrollableSelectors = [
          '.overflow-y-auto', 
          '.overflow-auto', 
          '.scroll-auto',
          '[data-scroll-container]',
          '.scrollable'
        ];
        
        scrollableSelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            element.scrollTop = 0;
          });
        });
        
        // Method 5: Reset main content area
        const mainElement = document.querySelector('main');
        if (mainElement) {
          mainElement.scrollTop = 0;
        }
        
        // Method 6: Reset root element
        const rootElement = document.getElementById('root');
        if (rootElement) {
          rootElement.scrollTop = 0;
        }
        
        // Method 7: Reset any flex containers that might be scrollable
        const flexContainers = document.querySelectorAll('.flex, .flex-col');
        flexContainers.forEach(container => {
          if (container.scrollHeight > container.clientHeight) {
            container.scrollTop = 0;
          }
        });
        
      } catch (error) {
        console.error('Error scrolling to top:', error);
      }
    };

    // Execute immediately when pathname changes
    scrollToTop();
    
    // Execute after microtasks
    Promise.resolve().then(scrollToTop);
    
    // Execute after DOM updates
    const immediateTimeoutId = setTimeout(scrollToTop, 0);
    
    // Execute after potential async operations
    const delayedTimeoutId = setTimeout(scrollToTop, 100);
    
    // Execute after longer delay for heavy content
    const finalTimeoutId = setTimeout(scrollToTop, 300);
    
    return () => {
      clearTimeout(immediateTimeoutId);
      clearTimeout(delayedTimeoutId);
      clearTimeout(finalTimeoutId);
    };
  }, [pathname]);
};

export default useScrollToTop;